import React from 'react';

export type FilterType = React.RefObject<HTMLDivElement> | null;

const FilterContext = React.createContext<FilterType>(null);

export const FilterProvider = FilterContext.Provider;

export default FilterContext;
